<div class="attachment-viewer-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Attachment Viewer</h2>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @if (currentDocument) {
      <!-- Document Viewer -->
      <div class="document-viewer-container">
        @if (currentDocument.isPdf || currentDocument.isImage || currentDocument.isOfficeDocument) {
          <iframe [src]="currentDocument.safeViewerUrl" 
                  width="100%" 
                  height="600px"
                  frameborder="0"
                  [title]="currentDocument.fileName"
                  class="document-iframe">
          </iframe>
        } @else {
          <div class="unsupported-file">
            <mat-icon class="large-icon">description</mat-icon>
            <p class="file-name">{{ currentDocument.fileName }}</p>
            <p class="file-info">Preview not available for this file type</p>
          </div>
        }
      </div>

      <!-- File Info & Actions -->
      <div class="file-info-section">
        <div class="file-details">
          <mat-icon>description</mat-icon>
          <div>
            <strong>{{ currentDocument.fileName }}</strong>
            <span class="file-type">{{ currentDocument.fileType.toUpperCase() }} File</span>
          </div>
        </div>

        <div class="file-actions">
          <button mat-stroked-button (click)="downloadAttachment()">
            <mat-icon>download</mat-icon>
            Download
          </button>
          <button mat-stroked-button (click)="openInNewTab()">
            <mat-icon>open_in_new</mat-icon>
            Open in New Tab
          </button>
        </div>
      </div>

      <!-- Associated Entity Links -->
      @if (currentAttachment.associatedEntityId) {
        <div class="associated-entities">
          <h3>Associated With:</h3>
          <div class="entity-links">
            @if (currentAttachment.associatedEntityType === 'Contract') {
              <button mat-button (click)="openContractWithAttachment(currentAttachment.associatedEntityId)">
                <mat-icon>description</mat-icon>
                View Contract
              </button>
            }
            @if (currentAttachment.associatedEntityType === 'COI') {
              <button mat-button (click)="openCoiWithAttachment(currentAttachment.associatedEntityId)">
                <mat-icon>shield</mat-icon>
                View COI
              </button>
            }
            @if (currentAttachment.associatedEntityType === 'BAA') {
              <button mat-button (click)="openBaaWithAttachment(currentAttachment.associatedEntityId)">
                <mat-icon>security</mat-icon>
                View BAA
              </button>
            }
            @if (currentAttachment.associatedEntityType === 'Party') {
              <button mat-button (click)="openPartyWithAttachment(currentAttachment.associatedEntityId)">
                <mat-icon>business</mat-icon>
                View Party
              </button>
            }
            @if (currentAttachment.associatedEntityType === 'Person') {
              <button mat-button (click)="openPersonWithAttachment(currentAttachment.associatedEntityId)">
                <mat-icon>person</mat-icon>
                View Person
              </button>
            }
          </div>
        </div>
      }

    } @else {
      <div class="no-attachment">
        <mat-icon class="large-icon">insert_drive_file</mat-icon>
        <p>No attachment data available</p>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()">Close</button>
  </mat-dialog-actions>
</div>